import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.payment = ReducerFuncs }

export {
  Routes,
  Reducers
}
